import { type QueryHookOptions, useQuery } from "@apollo/client";
import { CollectionQuery } from "../graphql/queries";
import type {
  CollectionQueryType,
  CollectionQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useCollectionQuery = (
  options?: QueryHookOptions<CollectionQueryType, CollectionQueryVariablesType>
) => {
  return useQuery<CollectionQueryType, CollectionQueryVariablesType>(
    CollectionQuery,
    options
  );
};
